module.exports = __webpack_public_path__ + "img/agent-pen.2e2ec3b7.svg";